/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TaskCreationRequestDto } from '../models';
// @ts-ignore
import type { TaskDto } from '../models';
// @ts-ignore
import type { TaskIdentifierDto } from '../models';
// @ts-ignore
import type { TaskMessageCreationRequestDto } from '../models';
// @ts-ignore
import type { TaskMessageIdDto } from '../models';
// @ts-ignore
import type { TaskUpdateRequestDto } from '../models';
// @ts-ignore
import type { TasksPageableResponseDto } from '../models';
// @ts-ignore
import type { TasksSearchRequestDto } from '../models';
// @ts-ignore
import type { UpdateTaskStatusRequestDto } from '../models';
/**
 * RestTasksApi - axios parameter creator
 */
export const RestTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add task message
         * @param {string} taskId 
         * @param {TaskMessageCreationRequestDto} taskMessageCreationRequestDto Create task message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaskMessage: async (taskId: string, taskMessageCreationRequestDto: TaskMessageCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('addTaskMessage', 'taskId', taskId)
            // verify required parameter 'taskMessageCreationRequestDto' is not null or undefined
            assertParamExists('addTaskMessage', 'taskMessageCreationRequestDto', taskMessageCreationRequestDto)
            const localVarPath = `/api/tasks/{taskId}/messages`
                .replace('{taskId}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskMessageCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new task
         * @param {TaskCreationRequestDto} taskCreationRequestDto Create task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (taskCreationRequestDto: TaskCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskCreationRequestDto' is not null or undefined
            assertParamExists('createTask', 'taskCreationRequestDto', taskCreationRequestDto)
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete task message
         * @param {string} taskId 
         * @param {number} taskMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskMessage: async (taskId: string, taskMessageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteTaskMessage', 'taskId', taskId)
            // verify required parameter 'taskMessageId' is not null or undefined
            assertParamExists('deleteTaskMessage', 'taskMessageId', taskMessageId)
            const localVarPath = `/api/tasks/{taskId}/messages/{taskMessageId}`
                .replace('{taskId}', encodeURIComponent(String(taskId)))
                .replace('{taskMessageId}', encodeURIComponent(String(taskMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get task by id
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTask', 'taskId', taskId)
            const localVarPath = `/api/tasks/{taskId}`
                .replace('{taskId}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dashboard list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboardTasks: async (page: number, pageSize: number, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchDashboardTasks', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchDashboardTasks', 'pageSize', pageSize)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('searchDashboardTasks', 'userId', userId)
            const localVarPath = `/api/tasks/dashboard-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {TasksSearchRequestDto} tasksSearchRequestDto Tasks search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks: async (page: number, pageSize: number, tasksSearchRequestDto: TasksSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchTasks', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchTasks', 'pageSize', pageSize)
            // verify required parameter 'tasksSearchRequestDto' is not null or undefined
            assertParamExists('searchTasks', 'tasksSearchRequestDto', tasksSearchRequestDto)
            const localVarPath = `/api/tasks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tasksSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update task by id
         * @param {string} taskId 
         * @param {TaskUpdateRequestDto} taskUpdateRequestDto Update task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: async (taskId: string, taskUpdateRequestDto: TaskUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTask', 'taskId', taskId)
            // verify required parameter 'taskUpdateRequestDto' is not null or undefined
            assertParamExists('updateTask', 'taskUpdateRequestDto', taskUpdateRequestDto)
            const localVarPath = `/api/tasks/{taskId}`
                .replace('{taskId}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update task\'s status
         * @param {string} taskId 
         * @param {UpdateTaskStatusRequestDto} updateTaskStatusRequestDto Update Task status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus: async (taskId: string, updateTaskStatusRequestDto: UpdateTaskStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTaskStatus', 'taskId', taskId)
            // verify required parameter 'updateTaskStatusRequestDto' is not null or undefined
            assertParamExists('updateTaskStatus', 'updateTaskStatusRequestDto', updateTaskStatusRequestDto)
            const localVarPath = `/api/tasks/{taskId}/status`
                .replace('{taskId}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestTasksApi - functional programming interface
 */
export const RestTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add task message
         * @param {string} taskId 
         * @param {TaskMessageCreationRequestDto} taskMessageCreationRequestDto Create task message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTaskMessage(taskId: string, taskMessageCreationRequestDto: TaskMessageCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskMessageIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTaskMessage(taskId, taskMessageCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.addTaskMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create new task
         * @param {TaskCreationRequestDto} taskCreationRequestDto Create task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(taskCreationRequestDto: TaskCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskIdentifierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(taskCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.createTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete task message
         * @param {string} taskId 
         * @param {number} taskMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskMessage(taskId: string, taskMessageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskMessage(taskId, taskMessageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.deleteTaskMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get task by id
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.getTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dashboard list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDashboardTasks(page: number, pageSize: number, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDashboardTasks(page, pageSize, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.searchDashboardTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {TasksSearchRequestDto} tasksSearchRequestDto Tasks search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTasks(page: number, pageSize: number, tasksSearchRequestDto: TasksSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTasks(page, pageSize, tasksSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.searchTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update task by id
         * @param {string} taskId 
         * @param {TaskUpdateRequestDto} taskUpdateRequestDto Update task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTask(taskId: string, taskUpdateRequestDto: TaskUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTask(taskId, taskUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.updateTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update task\'s status
         * @param {string} taskId 
         * @param {UpdateTaskStatusRequestDto} updateTaskStatusRequestDto Update Task status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskStatus(taskId: string, updateTaskStatusRequestDto: UpdateTaskStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskStatus(taskId, updateTaskStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestTasksApi.updateTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestTasksApi - factory interface
 */
export const RestTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestTasksApiFp(configuration)
    return {
        /**
         * 
         * @summary Add task message
         * @param {string} taskId 
         * @param {TaskMessageCreationRequestDto} taskMessageCreationRequestDto Create task message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaskMessage(taskId: string, taskMessageCreationRequestDto: TaskMessageCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskMessageIdDto> {
            return localVarFp.addTaskMessage(taskId, taskMessageCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new task
         * @param {TaskCreationRequestDto} taskCreationRequestDto Create task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(taskCreationRequestDto: TaskCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskIdentifierDto> {
            return localVarFp.createTask(taskCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete task message
         * @param {string} taskId 
         * @param {number} taskMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskMessage(taskId: string, taskMessageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTaskMessage(taskId, taskMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get task by id
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(taskId: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskDto> {
            return localVarFp.getTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dashboard list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboardTasks(page: number, pageSize: number, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<TasksPageableResponseDto> {
            return localVarFp.searchDashboardTasks(page, pageSize, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of tasks
         * @param {number} page 
         * @param {number} pageSize 
         * @param {TasksSearchRequestDto} tasksSearchRequestDto Tasks search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks(page: number, pageSize: number, tasksSearchRequestDto: TasksSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TasksPageableResponseDto> {
            return localVarFp.searchTasks(page, pageSize, tasksSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update task by id
         * @param {string} taskId 
         * @param {TaskUpdateRequestDto} taskUpdateRequestDto Update task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(taskId: string, taskUpdateRequestDto: TaskUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTask(taskId, taskUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update task\'s status
         * @param {string} taskId 
         * @param {UpdateTaskStatusRequestDto} updateTaskStatusRequestDto Update Task status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus(taskId: string, updateTaskStatusRequestDto: UpdateTaskStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTaskStatus(taskId, updateTaskStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestTasksApi - interface
 */
export interface RestTasksApiInterface {
    /**
     * 
     * @summary Add task message
     * @param {string} taskId 
     * @param {TaskMessageCreationRequestDto} taskMessageCreationRequestDto Create task message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTaskMessage(taskId: string, taskMessageCreationRequestDto: TaskMessageCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskMessageIdDto>;

    /**
     * 
     * @summary Create new task
     * @param {TaskCreationRequestDto} taskCreationRequestDto Create task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTask(taskCreationRequestDto: TaskCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskIdentifierDto>;

    /**
     * 
     * @summary Delete task message
     * @param {string} taskId 
     * @param {number} taskMessageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskMessage(taskId: string, taskMessageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get task by id
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTask(taskId: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskDto>;

    /**
     * 
     * @summary Get dashboard list of tasks
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDashboardTasks(page: number, pageSize: number, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<TasksPageableResponseDto>;

    /**
     * 
     * @summary Get list of tasks
     * @param {number} page 
     * @param {number} pageSize 
     * @param {TasksSearchRequestDto} tasksSearchRequestDto Tasks search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchTasks(page: number, pageSize: number, tasksSearchRequestDto: TasksSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TasksPageableResponseDto>;

    /**
     * 
     * @summary Update task by id
     * @param {string} taskId 
     * @param {TaskUpdateRequestDto} taskUpdateRequestDto Update task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTask(taskId: string, taskUpdateRequestDto: TaskUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update task\'s status
     * @param {string} taskId 
     * @param {UpdateTaskStatusRequestDto} updateTaskStatusRequestDto Update Task status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTaskStatus(taskId: string, updateTaskStatusRequestDto: UpdateTaskStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestTasksApi - object-oriented interface
 */
export class RestTasksApi extends BaseAPI implements RestTasksApiInterface {
    /**
     * 
     * @summary Add task message
     * @param {string} taskId 
     * @param {TaskMessageCreationRequestDto} taskMessageCreationRequestDto Create task message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addTaskMessage(taskId: string, taskMessageCreationRequestDto: TaskMessageCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).addTaskMessage(taskId, taskMessageCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new task
     * @param {TaskCreationRequestDto} taskCreationRequestDto Create task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTask(taskCreationRequestDto: TaskCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).createTask(taskCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete task message
     * @param {string} taskId 
     * @param {number} taskMessageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTaskMessage(taskId: string, taskMessageId: number, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).deleteTaskMessage(taskId, taskMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get task by id
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTask(taskId: string, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).getTask(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dashboard list of tasks
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDashboardTasks(page: number, pageSize: number, userId: string, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).searchDashboardTasks(page, pageSize, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of tasks
     * @param {number} page 
     * @param {number} pageSize 
     * @param {TasksSearchRequestDto} tasksSearchRequestDto Tasks search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchTasks(page: number, pageSize: number, tasksSearchRequestDto: TasksSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).searchTasks(page, pageSize, tasksSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update task by id
     * @param {string} taskId 
     * @param {TaskUpdateRequestDto} taskUpdateRequestDto Update task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTask(taskId: string, taskUpdateRequestDto: TaskUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).updateTask(taskId, taskUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update task\'s status
     * @param {string} taskId 
     * @param {UpdateTaskStatusRequestDto} updateTaskStatusRequestDto Update Task status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTaskStatus(taskId: string, updateTaskStatusRequestDto: UpdateTaskStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestTasksApiFp(this.configuration).updateTaskStatus(taskId, updateTaskStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

